/* eslint-disable */
import React, { useMemo, useState, useRef } from 'react';
import { CTitle } from '../../components/Widget';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import ImgPoint from '../../../../../../assets/cybersecurity2026/finger.gif';
import phishing from '../../../../../../assets/cybersecurity2026/topic1000/section2_1.png';
import { Modal } from 'antd';
interface ISection2Props {
  settings: any;
}

const Section3: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const ID = '4';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(() => settings?.paragraphs[3], [settings]);
  const updateComponentState = useUpdateComponentState();
  const [factorPlay, setFactorPlay] = useState(1);
  const [visibleCount, setVisibleCount] = useState(1);
  const [animationStarted, setAnimationStarted] = useState(false);
  const isFactorPlayingRef = useRef(false);
  const [open, setOpen] = useState<boolean>(false);
  const startFactorPlay = React.useCallback(() => {
    if (isFactorPlayingRef.current || factorPlay > 5) return;
    isFactorPlayingRef.current = true;
    setFactorPlay(2);
  }, [factorPlay]);

  React.useEffect(() => {
    if (factorPlay > 1 && factorPlay <= 5) {
      const timer = setTimeout(() => setFactorPlay((prev) => prev + 1), 1000);
      return () => clearTimeout(timer);
    }
    if (factorPlay >= 6) {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'cybersecurity2026-topic1000-section3-1'
      );
    }
  }, [factorPlay]);

  React.useEffect(() => {
    if (!animationStarted || visibleCount >= paragraphsSettings.risks?.length)
      return;
    const timer = setTimeout(() => setVisibleCount((v) => v + 1), 600);
    return () => clearTimeout(timer);
  }, [visibleCount, animationStarted, paragraphsSettings.risks?.length]);

  const handleArrowClick = React.useCallback(() => {
    if (animationStarted) return;
    setAnimationStarted(true);
    setVisibleCount(2);
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'cybersecurity2026-topic1000-section3-2'
    );
  }, [animationStarted, p_course, p_topic, updateComponentState]);

  return (
    <div className="topic-section-3">
      <div className="section-item1">
        <CTitle title={paragraphsSettings.title} />
        <div className="section-item1-content">
          <div className="content-left">{paragraphsSettings?.l2}</div>
          <div className="content-right">{paragraphsSettings?.r2}</div>
        </div>
      </div>
      <div
        className="factor-content"
        id="cybersecurity2026-topic1000-section3-1"
        onClick={startFactorPlay}
      >
        {factorPlay <= 1 && <img src={ImgPoint} alt="" className="img-point" />}
        <div className="factor-tips">{paragraphsSettings?.l1RightListDesc}</div>
        {paragraphsSettings?.l1RightList?.map((item: any, i: number) => (
          <div
            className={`factor-item factor-item-${i + 1} ${
              factorPlay > i ? 'box-fade-right-in' : ''
            }`}
            key={i}
          >
            <div>
              {item?.text}
              {item?.tips && (
                <span
                  className="factor-item-tips"
                  onClick={() => setOpen(true)}
                >
                  {item?.tips}
                </span>
              )}
              {item?.text2 && <span>{item?.text2}</span>}
            </div>
          </div>
        ))}
      </div>
      <div className="account-management">
        <i className="back_piece"></i>
        <div className="content" id="cybersecurity2026-topic1000-section3-2">
          {!animationStarted && (
            <img className="arrow-img" src={ImgPoint} alt="" />
          )}
          <div className="left-list" onClick={handleArrowClick}>
            {paragraphsSettings.risks?.map((r: any, i: number) => (
              <div
                key={i}
                className="risk-item"
                data-show={i < visibleCount}
                style={{
                  cursor: i === 0 && !animationStarted ? 'pointer' : 'default',
                }}
              >
                <div className="risk-title">{r.title}</div>
                <div className="risk-desc">{r.desc}</div>
              </div>
            ))}
          </div>
          <div className="m-left-list" onClick={handleArrowClick}>
            {paragraphsSettings.risks?.map((r: any, i: number) => (
              <div
                key={i}
                className="risk-item"
                data-show={i < visibleCount}
                style={{
                  cursor: i === 0 && !animationStarted ? 'pointer' : 'default',
                }}
              >
                <div className="risk-title">{r.title}</div>
                <div className="risk-desc">{r.desc}</div>
              </div>
            ))}
          </div>
          <div className="right-pic">
            <div className="risks-title">{paragraphsSettings?.risksTitle}</div>
            <img src={phishing} alt="" />
          </div>
        </div>
      </div>
      <Modal
        title={''}
        width={'80%'}
        getContainer={false}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        wrapClassName="section3-modal"
      >
        <div className="multiple">
          {paragraphsSettings?.multiple?.map((item: any, i: number) => (
            <div className="multiple-item" key={i}>
              <h5>{item.title}</h5>
              <div className="multiple-item-desc">{item.desc}</div>
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
};

export default Section3;
